import { useState } from 'react';
import { CaspioConfigForm } from './caspio-config-form';
import {
  defaultCaspioConfig,
  hasCustomCredentials,
  isCaspioConfigComplete,
  parseCaspioConfig,
  withCredentialVisibility,
} from './caspio-config';
import { crmTypeLabels } from './crm-config';
import { useCrmOverrideActions } from './crm-override-actions';
import { CrmOverrideModal } from './crm-override-modal';
import type { SystemOrganizationPhoneNumber } from './graphql';

export function CaspioPhoneOverrideModal({
  phoneNumber,
  onClose,
}: {
  phoneNumber: SystemOrganizationPhoneNumber;
  onClose: () => void;
}) {
  const existing = phoneNumber.crmIntegration;
  const initialConfig = existing ? parseCaspioConfig(existing.config) : defaultCaspioConfig;

  const [name, setName] = useState(existing?.name ?? `${phoneNumber.phoneNumber} CRM Override`);
  const [config, setConfig] = useState(initialConfig);
  const [showCredentials, setShowCredentials] = useState(hasCustomCredentials(initialConfig));
  const { error, isSaving, save } = useCrmOverrideActions(phoneNumber, onClose);

  return (
    <CrmOverrideModal
      typeLabel={crmTypeLabels.caspio}
      isExisting={Boolean(existing)}
      name={name}
      onNameChange={setName}
      error={error}
      isSaving={isSaving}
      canSave={isCaspioConfigComplete(config)}
      onSave={() => void save({ name, type: 'caspio', config: withCredentialVisibility(config, showCredentials) })}
      onClose={onClose}
    >
      <CaspioConfigForm
        config={config}
        onConfigChange={setConfig}
        showCredentials={showCredentials}
        onShowCredentialsChange={setShowCredentials}
        integrationId={existing?.id}
      />
    </CrmOverrideModal>
  );
}
